import { render, staticRenderFns } from "./IrisTextarea.vue?vue&type=template&id=5c1f45e8&"
import script from "./IrisTextarea.vue?vue&type=script&lang=ts&"
export * from "./IrisTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./IrisTextarea.vue?vue&type=style&index=0&id=5c1f45e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports